module.exports = __webpack_public_path__ + "static/media/DSC_0337.c6ef2820.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0337.jpg
// module id = 665
// module chunks = 0